module.exports = __webpack_public_path__ + "static/media/Poppins-SemiBold.df81bc40.ttf";